__turbopack_context__.v({
  "body": "index-module__akooNW__body",
  "close": "index-module__akooNW__close",
  "description": "index-module__akooNW__description",
  "header": "index-module__akooNW__header",
  "root": "index-module__akooNW__root",
  "title": "index-module__akooNW__title",
});
